/**
 * Leaflet のカスタムペイン名定数
 */
export const DRAWN_SHAPES_PANE_NAME = "drawnShapesPane";
export const CURRENT_LOCATION_PANE_NAME = "currentLocationPane";
export const COVERAGE_STROKE_PANE_NAME = "trustart-chiban-coverage-stroke";
export const COVERAGE_STROKE_PANE_CLASS = `leaflet-${COVERAGE_STROKE_PANE_NAME}-pane`;
